import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

// import ErrBoundary from '../src/components/ErrorBoundary'; // Import your ErrBoundary component

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
